export default __webpack_public_path__ + "static/acc-opening-banner-desktop-bd4be42deeb69ce03c2856bdf558483e.png";